import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";
export function AppointmentReminderPopup({
  appointmentReminder,
  setAppointmentReminder,
  handleJoinMeeting,
  meetindData,
}) {
  const handleRejoin = () => {
    setAppointmentReminder(!appointmentReminder);
  };

  return (
    <>
      <ModalCstm size="sm" centered show={appointmentReminder} onHide={handleRejoin}>
        <Modal.Body
          onClick={() => {
           // handleJoinMeeting(meetindData);
            handleRejoin();
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleRejoin();
            }}
            className="position-absolute border-0 p-0 bg-transparent"
            style={{ top: 5, right: 5 }}
          >
            {closeIcn}
          </button>
          <div className="text-center">
            <h4 className="m-0 fw-normal">
              10:00am <br /> APPOINTMENT{" "}
            </h4>
            <h3 className="m-0 themeClr fw-bold">
              {parseInt(localStorage.getItem("user_login_type_role")) === 2
                ? `Dr. ${localStorage.getItem("user_name")}`
                : `Mr. ${localStorage.getItem("user_name")}`}
            </h3>
            {/* <h4 className="m-0 themeClr fw-bold">Dr. Pauli</h4> */}
            <h2 className="m-0 themeClr fw-bold cursor-pointer">JOIN</h2>
            <h3 className="m-0 themeClr fw-bold">
              {parseInt(localStorage.getItem("user_login_type_role")) !== 2
                ? `Dr. ${meetindData?.doctor_information?.doctor_full_name}`
                : `Mr. ${meetindData?.patient_information?.patient_full_name}`}
            </h3>
          </div>
        </Modal.Body>{" "}
      </ModalCstm>
    </>
  );
}

const ModalCstm = styled(Modal)`
  .modal-sm {
    max-width: 230px;
    margin: 0 auto;
    .modal-content {
      border: 2px solid #3add30;
      border-radius: 30px;
    }
  }
`;

// export default RejoinPopup
const closeIcn = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2)">
      <mask
        id="mask0_1_2"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="22"
        height="22"
      >
        <path
          d="M9.94527 24.0874C13.8595 27.9836 20.1911 27.969 24.0874 24.0547C27.9836 20.1405 27.969 13.8089 24.0548 9.91265C20.1405 6.01642 13.8089 6.03102 9.91266 9.94526C6.01644 13.8595 6.03104 20.1911 9.94527 24.0874Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.296 13.8058L20.1697 11.6894L16.9951 14.8787L13.8058 11.7041L11.6894 13.8303L14.8787 17.0049L11.7041 20.1942L13.8303 22.3106L17.0049 19.1213L20.1942 22.2959L22.3106 20.1697L19.1213 16.9951L22.296 13.8058Z"
          fill="black"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1_2)">
        <path
          d="M16.9609 0.0294824L33.9705 16.9609L17.0391 33.9705L0.0294914 17.0391L16.9609 0.0294824Z"
          fill="#216fc8"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(16.9609 0.0294824) rotate(44.8679)"
        />
      </clipPath>
    </defs>
  </svg>
);
